module.exports = __webpack_public_path__ + "static/media/slide-5.aaee0d92.webp";